import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { useForm, FormContextInterface } from "../context";

const TermsCondition = () => {
  const { termsCondition, schoolInfo } = useForm() as FormContextInterface;

  const FeePrimary = termsCondition.find((item) => item.title === "FeePrimary");
  const DeadlineNoticePeriod = termsCondition.find(
    (item) => item.title === "DeadlineNoticePeriod"
  );
  const Term1DeadlineHeader = termsCondition.find(
    (item) => item.title === "Term1DeadlineHeader"
  );
  const Term1DeadlineValue = termsCondition.find(
    (item) => item.title === "Term1DeadlineValue"
  );
  const Term2DeadlineHeader = termsCondition.find(
    (item) => item.title === "Term2DeadlineHeader"
  );
  const Term2DeadlineValue = termsCondition.find(
    (item) => item.title === "Term2DeadlineValue"
  );
  const Term3DeadlineHeader = termsCondition.find(
    (item) => item.title === "Term3DeadlineHeader"
  );
  const Term3DeadlineValue = termsCondition.find(
    (item) => item.title === "Term3DeadlineValue"
  );
  return (
    <Stack spacing={3} marginTop={5} p={3} sx={{ textAlign: "justify" }}>

      <Typography
        color={"primary"}
        display="flex"
        variant="h5"
        justifyContent={"center"}
        marginY={3}
        sx={{ fontSize: "1.1rem !important", fontWeight: "bold" }}
      >
        Terms & Conditions
      </Typography>

        <>
          <Typography style={{ textAlign: "justify" }}>
            M:Tech is an ongoing music course and an extension of the school music offering.
            As such we operate with a clear set of Terms & Conditions which are similar to those of an instrumental lesson
            and distinctly different from school clubs.
          </Typography>
          <Typography style={{ textAlign: "justify" }}>
            Please read these below in order to understand how the M:Tech course is run.
            <br /><br />
            </Typography>
            <Typography>
            <span style={{ textDecoration: "underline" }}>
            You will need to affirmatively acknowledge these terms in order to complete your child’s registration with us.
            Our Terms & Conditions come into effect once we have confirmed a place on our timetable for your child.
            </span>
          </Typography>
          <Typography style={{ textAlign: "justify" }}>
            M:Tech reserves the right to alter these Terms & Conditions if necessary.
          </Typography>
        
          <Typography style={{ textAlign: "justify" }}>
            <Box component="span" sx={{ color: "primary.main", textDecoration: "underline",fontWeight: "bold" }}>
              Lessons:
               <br />
            </Box>
            M:Tech delivers as many weekly sessions as the school calendar allows. The number of
            lessons each term may vary due to term and holiday dates but typically we will aim to deliver
            30 sessions over the course of a calendar year.
            <br /><br />
            M:Tech reserves the right to change teaching personnel, lesson times and learner
            groupings where necessary. We will notify parents of changes where possible.
            <br /><br />
            M:Tech does not offer trial lessons.
          </Typography>
          <Typography style={{ textAlign: "justify" }}>
            <Box component="span" sx={{ color: "primary.main", textDecoration: "underline",fontWeight: "bold" }}>
              Fees:
               <br />
            </Box>
            Payment for M:Tech lessons is due termly in advance.
            <br /><br />
            Invoices are sent at the end of the prior term and are payable upon presentation, but you will also be offered the option of spreading your payments over three months via Direct Debit.
            <br /><br />
            Learners retain their M:Tech place and are automatically re-enrolled and invoiced each
            term unless appropriate notice has been given (see Notice below).
            <br /><br />
            In the event of continued non-payment we reserve the right to discontinue service until
            full payment has been received or further discussion has taken place.
            <br /><br />
            Fees will not be refundable for any absence or short-term illness. In the case of longer
            term absence from school, please contact us so we can make the appropriate arrangements.
            <br /><br />
            If you are experiencing any financial difficulty, please contact the M:Tech Accounts
            Department so that we can discuss alternative payment arrangements. All conversations
            and information will be dealt with in strict confidence and please be assured we are
             here to support you and your child’s ongoing experience with M:Tech.
            <br /><br />
            Fees are reviewed annually.

          </Typography>
          <Typography style={{ textAlign: "justify" }}>
            <Box component="span" sx={{ color: "primary.main", textDecoration: "underline", fontWeight: "bold" }}>
              Missed Lessons, Credits & Refunds:
               <br />
            </Box>
            M:Tech is unable to reimburse for missed lessons in the event of illness, forgetfulness or
            unforeseen circumstances beyond our control. This includes late or unscheduled cancellations by the school.
            <br /><br />
            In the event of teacher absence or illness every effort will be made to deliver the lesson, either
            via a suitable M:Tech cover teacher or by rescheduling for a later date. Where this is
            not possible, M:Tech will credit your account for the lesson and this will be deducted from the following
            term’s invoice.
            <br /><br />
            All credits are non-refundable but they are carried forward to be used against future terms. Non-refundable 
            credit balances are also transferrable between siblings.

          </Typography>

          <Typography style={{ textAlign: "justify" }}>
            <Box component="span" sx={{ color: "primary.main", textDecoration: "underline",fontWeight: "bold"}}>
              Family Discounts:
               <br />
            </Box>
            If your child has completed three terms of M:Tech and achieved their Bronze Level, an automatic 
            and ongoing 10% family discount will be applied to any further siblings who subsequently join the M:Tech course.
            <br /><br />
            In the event that you have two children starting at the same time, when both have completed three terms of M:Tech 
            and achieved their Bronze Level an ongoing 5% discount from Level 4 onwards will be applied to each child. Should 
            either sibling subsequently stop M:Tech classes their 5% discount will be automatically applied to the continuing 
            sibling who will receive a discount of 10%.
            <br /><br />
            Family discounts are effective from September 2025 and have been introduced alongside the new M:Tech Bronze / Silver / Gold tier system.

          </Typography>

          {schoolInfo.noticePeriodRequired !== "N" && (
          <Typography style={{ textAlign: "justify" }}>
            <Box component="span" sx={{ color: "primary.main", textDecoration: "underline",fontWeight: "bold" }}>
              Withdrawal / Notice:
               <br />
            </Box>
            M:Tech lessons continue term on term and your child will automatically retain their place
            with M:Tech until appropriate written notice of withdrawal is received.
            <br /><br />
            Notice to withdraw from the course must be received directly via the Parent/Guardian section of our 
            MyMTech home portal on or before the deadline dates below in order to cease lessons at the end of a term.
            <br /><br />
            <Box>
              <Box marginBottom={2}>
                M:Tech notice deadlines for {DeadlineNoticePeriod?.details} are:
              </Box>
              <Typography
                sx={{
                  color: "#9900ff",
                  textAlign: "justify",
                  fontSize: "0.8rem"
                }}
              >
                <Box display={"flex"}  className="dates" >
                  {Term1DeadlineHeader?.details}
                  <Box marginLeft={6.8}>{Term1DeadlineValue?.details}</Box>
                </Box>
                <Box display={"flex"}  className="dates">
                  {Term2DeadlineHeader?.details}
                  <Box marginLeft={6.7}>{Term2DeadlineValue?.details}</Box>
                </Box>
                <Box display={"flex"}  className="dates">
                  {Term3DeadlineHeader?.details}
                  <Box marginLeft={5.4}>{Term3DeadlineValue?.details}</Box>
                </Box>
              </Typography>
           </Box>
          <br/>
            You will be charged 50% of one term’s fees for late notice which will be 
            held as a non-refundable credit. In the event you provide us late notice 
            and it is your child’s final term before leaving school there will be a 
            non-refundable and non-transferrable administration charge of £50.00
            <br /><br />
            Late notice fees can be redeemed against a future term either for the same 
            child or a sibling. The credit balance cannot be used against fees for a 
            sibling participating in the same term that the late notice fees apply to 
            but instead would be applied to the fee for the following term.
            <br /><br />
            <Box sx={{ fontStyle: "italic" }}>
              Notice deadlines exist to ensure good order and efficiency in all aspects 
              of our planning, which is vital to support the cost of operating our service. 
              These deadlines are firm and they are supported by {schoolInfo?.label}.
            </Box>
          </Typography>
          )} 

          <Typography style={{ textAlign: "justify" }}>
            <Box component="span" sx={{ color: "primary.main", textDecoration: "underline",fontWeight: "bold" }}>
              Behaviour:
               <br />
            </Box>
            At M:Tech, we prioritise creating a positive and inclusive learning environment where
            all participants feel respected, valued and safe. To ensure a productive and enjoyable
            experience for everyone we expect all of our learners to treat the class environment
            and everyone within it with courtesy, consideration and kindness.
            <br /><br />
            Poor attendance, repeated disruptive or anti-social behaviour by the learner may result in their
            tuition being withdrawn. Any paid or outstanding fees would be retained or remain payable.
            No credits will be given in such circumstances.

          </Typography>

          <Typography style={{ textAlign: "justify"}}>
            <Box component="span" sx={{ color: "primary.main", textDecoration: "underline", fontWeight: "bold"  }}>
              Medical & Special Educational Needs & Disabilities:
               <br />
            </Box>
            M:Tech endeavour to support all learners and our aim is to help them to fulfil their creative potential through an enjoyable music-making experience.
            <br /><br />
            Parents/carers must inform M:Tech of any additional
            needs or relevant medical conditions either via the application form or in writing via email to:
            <a href="mailto:office@mtechonline.co.uk" target="_blank" style={{color:"blue"}}> office@mtechonline.co.uk</a>
            <br /><br />
            Parents/carers must also inform us of relevant changes to the learners medical condition or educational needs.
          </Typography>

          <Typography style={{ textAlign: "justify" }}>
            <Box component="span" sx={{ color: "primary.main", textDecoration: "underline", fontWeight: "bold" }}>
              Personal Data:
               <br />
            </Box>
            You agree to M:Tech recording your information for the sole purpose of
            administering the course. M:Tech are GDPR compliant and will not share your
            data with other companies or organisations.
            <br /><br />
            Please see our Privacy Notice for full details of how we process personal data:
            <a href="https://mtechonline.co.uk/privacy" target="_blank" style={{color:"blue"}} > https://mtechonline.co.uk/privacy</a>

          </Typography>
        </>
    </Stack>
  );
};

export { TermsCondition };
